<template>
  <div class="bx--snippet bx--snippet--multi">
    <div class="bx--snippet-container">
      <slot />
    </div>
  </div>
</template>

<style>
.bx--snippet--multi .bx--snippet-container pre {
  padding-bottom: 0;
}
</style>
